// 관리자용 Firebase 설정
// 이 파일은 관리자 대시보드에서만 사용됩니다.

import { getAuth } from 'firebase/auth';
import app from './firebase';

const FUNCTIONS_BASE_URL = 'https://us-central1-tobeai-cs.cloudfunctions.net';

// Firebase Auth 토큰 가져오기
const getAuthToken = async () => {
    const auth = getAuth(app);
    const user = auth.currentUser;
    if (!user) {
        throw new Error('로그인이 필요합니다.');
    }
    return await user.getIdToken();
};

// 문의 목록 조회 (관리자용)
export const getInquiries = async (params = {}) => {
    const token = await getAuthToken();
    const queryString = new URLSearchParams(params).toString();

    const response = await fetch(`${FUNCTIONS_BASE_URL}/getInquiries?${queryString}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || '문의 목록 조회 중 오류가 발생했습니다.');
    }

    return response.json();
};

// 문의 상태 업데이트 (관리자용)
export const updateInquiryStatus = async (data) => {
    const token = await getAuthToken();

    const response = await fetch(`${FUNCTIONS_BASE_URL}/updateInquiryStatus`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || '문의 상태 업데이트 중 오류가 발생했습니다.');
    }

    return response.json();
}; 